import { Pipe, PipeTransform } from '@angular/core';

import { parameterColor } from '../constants/constants';

@Pipe({ name: 'parameterColor' })
export class ParameterColorPipe implements PipeTransform {
  transform(parameter: string) {
    return parameterColor(parameter);
  }
}
